const defaultTemplate = 'default';
const shoppingCart = require('od-modules/cart/cart');

const rules = [
    {
        template: 'payWithGuarantee',
        validator(model) {
            return model.isPayWithGuaranteeEnabled();
        },
        hideTotalPrice: true,
        continueTracking: 'continueWithInsurance',
    },
    {
        template: defaultTemplate,
        continueTracking: 'continue',
    },
];

const createInsuranceShoppingCartItem = (insuranceItem) => {
    shoppingCart.builders.insurance.data({
        id: insuranceItem.id,
        type: insuranceItem.policy,
        price: {
            total: insuranceItem.totalPrice,
        },
    }).fromContinueButton().add();
};

module.exports = {
    rules,
    defaultTemplate,
    onContinueTrigger: 'payment-button:bookFlight',
    onContinueButtonMouseOver: null,
    onContinueWithPayWithGuarantee(model, productId, onSuccessCallback) {
        createInsuranceShoppingCartItem(model.getCancellationGuarantee());
        shoppingCart.commit().then(() => {
            Odigeo.trigger('payment-button:addProductSuccess', {productId});
            onSuccessCallback();
        });
    },
    isAnyInsurancesInCartOrInSession(model) {
        return model.isAnyInsurancesInCart();
    },
    ab: {
        payWithGuarantee: {
            isReorderABEnabled: (abs) => abs['reorderPaymentRefundableFareMobile'],
        },
        voucherCanx: {
            isEnabled: (abs) => abs['c4arAsAVoucherMobile'],
        },
    },
    tracking: {
        labelForRejectedButton: 'none',
    },
};
